import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getUser } from '../../selectors/user';
import { IBrokerAnalyticsUser } from '../../tracking/newbuilding/broker';
import { TNewbuildingBrokerFlow } from '../../types/newbuildingBroker';

export const useNewbuildingBrokerAnalyticsUser = (flowType: TNewbuildingBrokerFlow | undefined) => {
  const user = useSelector(getUser);

  const userId = user?.isAuthenticated ? user.userId : undefined;

  return useMemo<IBrokerAnalyticsUser>(
    () => ({
      userId,
      extra: {
        is_individual: flowType === 'withPartnerRewards',
      },
    }),
    [userId, flowType],
  );
};
